export default {"src":"/polygon/_next/static/media/near.4a80e9d1.svg","height":80,"width":231};